'use strict';

/**
 * Test whether value is a boolean
 * @param {*} value
 * @return {boolean} isBoolean
 */

exports.isBoolean = function (value) {
  return typeof value === 'boolean';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/utils/boolean.js
// module id = BXAL
// module chunks = 0